import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateWorkspaceDto, Workspace } from '@app/shared/store/entities';

@Component({
  selector: 'app-workspace-form',
  templateUrl: './workspace-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkspaceFormComponent {
  @Output() deleted = new EventEmitter<string>();
  @Output() updated = new EventEmitter<UpdateWorkspaceDto>();

  private _workspace: Partial<Workspace>;

  @Input() set workspace(workspace: Partial<Workspace>) {
    this._workspace = workspace;
    this.form.patchValue(workspace);
  }

  get workspace() {
    return this._workspace;
  }

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      id: '',
      name: ['', [Validators.required, Validators.minLength(4)]],
      doc_number: '',
      duns_number: '',
      description: '',
      address: '',
      city: '',
      state: '',
      post_code: '',
      country: '',
    });
  }

  onSubmit() {
    this.updated.emit(this.form.value);
  }

  onDelete(id: string) {
    this.deleted.emit(id);
  }
}
